// Added by Sejune Oh on 2020-04-07
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react'
import {
  Container as MaterialUIContainer,
  ContainerProps as MaterialUIContainerProps,
} from '@material-ui/core'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
interface ContainerBaseProps {}
export type ContainerProps = MaterialUIContainerProps & ContainerBaseProps

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const Container:FC<ContainerProps> = ({...props}) => {
    return <MaterialUIContainer {...props} />
}
